<div id="topo" [ngClass]="{ 'modal-container': isModal }">
  <suite-rfb-collapse [collapsed]="filtroColapsado" (collapsedChange)="colapsar($event)" [title]="titulo">
    <suite-rfb-alert-messages-with-datetime [onlyFor]="scopeId"></suite-rfb-alert-messages-with-datetime>
    <ng-container *ngIf="exercicios && creditosTributarios; else loadingOrError">
      <div class="container-fluid" *ngFor="let exercicio of exercicios">
        <div class="exercicio">
          <div class="exercicio-toggle" style="float:left">
            <suite-rfb-toggle #rowToggleExercicio>
            </suite-rfb-toggle>
          </div>
          <div class="exercicio-titulo">
            {{ exercicio }}
          </div>
        </div>
        <ng-container *ngIf="rowToggleExercicio.show">
          <div class="exercicio-conteudo">
            <div class="table-responsive">
              <table suiteRfbTable>
                <thead>
                  <tr>
                    <th class="text-center min-width">Ações</th>
                    <th class="text-center min-width">
                      <suite-rfb-toggle title="Expandir/Contrair Todos" (expanded)="expandedAll($event)">
                      </suite-rfb-toggle>
                    </th>
                    <th class="text-center min-width">CT</th>
                    <th class="text-center min-width">Data de Venc. Notificação</th>
                    <th class="text-center">Valor Original</th>
                    <th class="text-center">Saldo Devedor</th>
                    <th class="text-center">Situação</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container
                    *ngFor="let credito of creditosTributarios[exercicio] | currentPage: currentPages[exercicio];"
                    class="vertical-align-middle">
                    <tr class="vertical-align-middle">
                      <td class="text-center">
                        <suite-rfb-popover-button #botaoAcoes [template]="menuAcoes"></suite-rfb-popover-button>
                        <ng-template #menuAcoes>
                          <div class="btn-group-vertical" role="group">
                            <button [disabled]="false" type="button" class="btn btn-default"
                              (click)="pagamentos(credito); botaoAcoes.hide();">
                              Pagamentos
                            </button>
                            <button [disabled]="false" type="button" class="btn btn-default"
                              (click)="onListarDebitos(credito); botaoAcoes.hide();">
                              Débito em Conta
                            </button>
                            <button [disabled]="false" type="button" class="btn btn-default"
                              (click)="onListarDemonstrativoCotas(credito); botaoAcoes.hide();">
                              Demonstrativo de Quotas
                            </button>
                            <button [disabled]="false" type="button" class="btn btn-default"
                              (click)="abreEventosCreditoTributarioFiltros(credito); botaoAcoes.hide();">
                              Eventos do CT
                            </button>
                            <button [disabled]="false" type="button" class="btn btn-default"
                              (click)="suspendeCreditoTributario(credito); botaoAcoes.hide();">
                              Suspender
                            </button>
                            <button [disabled]="false" type="button" class="btn btn-default"
                              (click)="reativaCreditoTributario(credito); botaoAcoes.hide();">
                              Reativar
                            </button>
                            <button [disabled]="false" type="button" class="btn btn-default"
                              (click)="transfereCreditoTributario(credito); botaoAcoes.hide();">
                              Transferir
                            </button>
                          </div>
                        </ng-template>
                      </td>
                      <td>
                        <suite-rfb-toggle #rowToggle></suite-rfb-toggle>
                      </td>
                      <td class="text-center">{{ credito.ct | vazio }}</td>
                      <td class="text-center">{{ credito.dataVencimentoNotificacao | formatDataPipe }}</td>
                      <td class="text-right">{{ credito.valorOriginal | formatCurrency }}</td>
                      <td class="text-right">{{ credito.saldoDevedor | formatCurrency }}</td>
                      <td class="text-left">{{ credito.situacao | vazio}}</td>
                    </tr>
                    <ng-container *ngIf="rowToggle.show">
                      <tr></tr>
                      <tr>
                        <td colspan="7">
                          <div class="contorno">
                            <div class="row">
                              <div class="col-md-4">
                                <label class="label-formulario control-label">
                                  Tipo Notificação
                                </label>
                                <p class="form-control-static dado-formulario">
                                  {{ credito.tipoNotificacao | codigoDescricao | vazio }}
                                </p>
                              </div>
                              <div class="col-md-4">
                                <label class="label-formulario control-label">
                                  Número da Declaração
                                </label>
                                <p class="form-control-static dado-formulario">
                                  {{ credito.numeroDeclaracao | vazio }}
                                </p>
                              </div>
                              <div class="col-md-4">
                                <label class="label-formulario control-label">
                                  Unidade Monetária
                                </label>
                                <p class="form-control-static dado-formulario">
                                  {{ credito.unidadeMonetaria | vazio }}
                                </p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-4">
                                <label class="label-formulario control-label">
                                  Número de Lançamento
                                </label>
                                <p class="form-control-static dado-formulario">
                                  {{ credito.numeroLancamento | vazio }}
                                </p>
                              </div>
                              <div class="col-md-8">
                                <label class="label-formulario control-label">
                                  N° do Processo
                                </label>
                                <p class="form-control-static dado-formulario">
                                  {{ credito.numeroProcesso | vazio }}
                                </p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-12">
                                <via-ccpf-table-componentes
                                  [atendimento]="atendimento"
                                  [cpf]="cpf"
                                  [credito]="credito"
                                  [componentes]="credito.componentes"
                                  [parametrosPesquisa]="parametros">
                                </via-ccpf-table-componentes>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-12">
                                <via-ccpf-table-pagamentos
                                  [atendimento]="atendimento"
                                  [pagamentos]="credito.pagamentos"
                                  [cpf]="cpf"
                                  [credito]="credito"
                                  [parametrosPesquisa]="parametros">
                                </via-ccpf-table-pagamentos>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                  </ng-container>
                </tbody>
                <tfoot>
                  <tr class="tabela-acoes text-left">
                    <td colspan="7">
                      <via-pagination
                        [itemAmount]="creditosTributarios[exercicio].length"
                        [(page)]="currentPages[exercicio]">
                      </via-pagination>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="tabela-acoes text-left total-consulta-ccpf" *ngIf="!initError">
        Total de Registros: {{ totalExercicios }}
      </div>
    </ng-container>
  </suite-rfb-collapse>
</div>

<ng-template #loadingOrError>
  <div *ngIf="initError; else loading">
  </div>
  <ng-template #loading>
    <loading-animation *ngIf="!stopLoading"></loading-animation>
  </ng-template>
</ng-template>
